/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckinRouteImport } from './routes/checkin'
import { Route as ConfiguracoesRouteImport } from './routes/configuracoes'
import { Route as ConfirmarNovoEmailRouteImport } from './routes/confirmar-novo-email'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as EntrevistaRouteImport } from './routes/entrevista'
import { Route as EsqueciASenhaRouteImport } from './routes/esqueci-a-senha'
import { Route as HistoricoRouteImport } from './routes/historico'
import { Route as NovidadesRouteImport } from './routes/novidades'
import { Route as PainelRouteImport } from './routes/painel'
import { Route as PlanoRouteImport } from './routes/plano'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as RedefinirSenhaRouteImport } from './routes/redefinir-senha'
import { Route as ResultadoRouteImport } from './routes/resultado'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as VerificarEmailRouteImport } from './routes/verificar-email'
import { Route as RegistroIdRouteImport } from './routes/registro.$id'
import { Route as TreinoIdRouteImport } from './routes/treino.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckinRoute = CheckinRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfiguracoesRoute = ConfiguracoesRouteImport.update({
  id: '/configuracoes',
  path: '/configuracoes',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmarNovoEmailRoute = ConfirmarNovoEmailRouteImport.update({
  id: '/confirmar-novo-email',
  path: '/confirmar-novo-email',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrevistaRoute = EntrevistaRouteImport.update({
  id: '/entrevista',
  path: '/entrevista',
  getParentRoute: () => rootRouteImport,
} as any)
const EsqueciASenhaRoute = EsqueciASenhaRouteImport.update({
  id: '/esqueci-a-senha',
  path: '/esqueci-a-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoricoRoute = HistoricoRouteImport.update({
  id: '/historico',
  path: '/historico',
  getParentRoute: () => rootRouteImport,
} as any)
const NovidadesRoute = NovidadesRouteImport.update({
  id: '/novidades',
  path: '/novidades',
  getParentRoute: () => rootRouteImport,
} as any)
const PainelRoute = PainelRouteImport.update({
  id: '/painel',
  path: '/painel',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanoRoute = PlanoRouteImport.update({
  id: '/plano',
  path: '/plano',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacidadeRoute = PrivacidadeRouteImport.update({
  id: '/privacidade',
  path: '/privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const RedefinirSenhaRoute = RedefinirSenhaRouteImport.update({
  id: '/redefinir-senha',
  path: '/redefinir-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultadoRoute = ResultadoRouteImport.update({
  id: '/resultado',
  path: '/resultado',
  getParentRoute: () => rootRouteImport,
} as any)
const TermosRoute = TermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => rootRouteImport,
} as any)
const VerificarEmailRoute = VerificarEmailRouteImport.update({
  id: '/verificar-email',
  path: '/verificar-email',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistroIdRoute = RegistroIdRouteImport.update({
  id: '/registro/$id',
  path: '/registro/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TreinoIdRoute = TreinoIdRouteImport.update({
  id: '/treino/$id',
  path: '/treino/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/checkin': typeof CheckinRoute
  '/configuracoes': typeof ConfiguracoesRoute
  '/confirmar-novo-email': typeof ConfirmarNovoEmailRoute
  '/entrar': typeof EntrarRoute
  '/entrevista': typeof EntrevistaRoute
  '/esqueci-a-senha': typeof EsqueciASenhaRoute
  '/historico': typeof HistoricoRoute
  '/novidades': typeof NovidadesRoute
  '/painel': typeof PainelRoute
  '/plano': typeof PlanoRoute
  '/privacidade': typeof PrivacidadeRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/resultado': typeof ResultadoRoute
  '/termos': typeof TermosRoute
  '/verificar-email': typeof VerificarEmailRoute
  '/registro/$id': typeof RegistroIdRoute
  '/treino/$id': typeof TreinoIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/checkin': typeof CheckinRoute
  '/configuracoes': typeof ConfiguracoesRoute
  '/confirmar-novo-email': typeof ConfirmarNovoEmailRoute
  '/entrar': typeof EntrarRoute
  '/entrevista': typeof EntrevistaRoute
  '/esqueci-a-senha': typeof EsqueciASenhaRoute
  '/historico': typeof HistoricoRoute
  '/novidades': typeof NovidadesRoute
  '/painel': typeof PainelRoute
  '/plano': typeof PlanoRoute
  '/privacidade': typeof PrivacidadeRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/resultado': typeof ResultadoRoute
  '/termos': typeof TermosRoute
  '/verificar-email': typeof VerificarEmailRoute
  '/registro/$id': typeof RegistroIdRoute
  '/treino/$id': typeof TreinoIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/checkin': typeof CheckinRoute
  '/configuracoes': typeof ConfiguracoesRoute
  '/confirmar-novo-email': typeof ConfirmarNovoEmailRoute
  '/entrar': typeof EntrarRoute
  '/entrevista': typeof EntrevistaRoute
  '/esqueci-a-senha': typeof EsqueciASenhaRoute
  '/historico': typeof HistoricoRoute
  '/novidades': typeof NovidadesRoute
  '/painel': typeof PainelRoute
  '/plano': typeof PlanoRoute
  '/privacidade': typeof PrivacidadeRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/resultado': typeof ResultadoRoute
  '/termos': typeof TermosRoute
  '/verificar-email': typeof VerificarEmailRoute
  '/registro/$id': typeof RegistroIdRoute
  '/treino/$id': typeof TreinoIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/checkin'
    | '/configuracoes'
    | '/confirmar-novo-email'
    | '/entrar'
    | '/entrevista'
    | '/esqueci-a-senha'
    | '/historico'
    | '/novidades'
    | '/painel'
    | '/plano'
    | '/privacidade'
    | '/redefinir-senha'
    | '/resultado'
    | '/termos'
    | '/verificar-email'
    | '/registro/$id'
    | '/treino/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/checkin'
    | '/configuracoes'
    | '/confirmar-novo-email'
    | '/entrar'
    | '/entrevista'
    | '/esqueci-a-senha'
    | '/historico'
    | '/novidades'
    | '/painel'
    | '/plano'
    | '/privacidade'
    | '/redefinir-senha'
    | '/resultado'
    | '/termos'
    | '/verificar-email'
    | '/registro/$id'
    | '/treino/$id'
  id:
    | '__root__'
    | '/'
    | '/checkin'
    | '/configuracoes'
    | '/confirmar-novo-email'
    | '/entrar'
    | '/entrevista'
    | '/esqueci-a-senha'
    | '/historico'
    | '/novidades'
    | '/painel'
    | '/plano'
    | '/privacidade'
    | '/redefinir-senha'
    | '/resultado'
    | '/termos'
    | '/verificar-email'
    | '/registro/$id'
    | '/treino/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CheckinRoute: typeof CheckinRoute
  ConfiguracoesRoute: typeof ConfiguracoesRoute
  ConfirmarNovoEmailRoute: typeof ConfirmarNovoEmailRoute
  EntrarRoute: typeof EntrarRoute
  EntrevistaRoute: typeof EntrevistaRoute
  EsqueciASenhaRoute: typeof EsqueciASenhaRoute
  HistoricoRoute: typeof HistoricoRoute
  NovidadesRoute: typeof NovidadesRoute
  PainelRoute: typeof PainelRoute
  PlanoRoute: typeof PlanoRoute
  PrivacidadeRoute: typeof PrivacidadeRoute
  RedefinirSenhaRoute: typeof RedefinirSenhaRoute
  ResultadoRoute: typeof ResultadoRoute
  TermosRoute: typeof TermosRoute
  VerificarEmailRoute: typeof VerificarEmailRoute
  RegistroIdRoute: typeof RegistroIdRoute
  TreinoIdRoute: typeof TreinoIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkin': {
      id: '/checkin'
      path: '/checkin'
      fullPath: '/checkin'
      preLoaderRoute: typeof CheckinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuracoes': {
      id: '/configuracoes'
      path: '/configuracoes'
      fullPath: '/configuracoes'
      preLoaderRoute: typeof ConfiguracoesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirmar-novo-email': {
      id: '/confirmar-novo-email'
      path: '/confirmar-novo-email'
      fullPath: '/confirmar-novo-email'
      preLoaderRoute: typeof ConfirmarNovoEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrevista': {
      id: '/entrevista'
      path: '/entrevista'
      fullPath: '/entrevista'
      preLoaderRoute: typeof EntrevistaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/esqueci-a-senha': {
      id: '/esqueci-a-senha'
      path: '/esqueci-a-senha'
      fullPath: '/esqueci-a-senha'
      preLoaderRoute: typeof EsqueciASenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/historico': {
      id: '/historico'
      path: '/historico'
      fullPath: '/historico'
      preLoaderRoute: typeof HistoricoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/novidades': {
      id: '/novidades'
      path: '/novidades'
      fullPath: '/novidades'
      preLoaderRoute: typeof NovidadesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/painel': {
      id: '/painel'
      path: '/painel'
      fullPath: '/painel'
      preLoaderRoute: typeof PainelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plano': {
      id: '/plano'
      path: '/plano'
      fullPath: '/plano'
      preLoaderRoute: typeof PlanoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacidade': {
      id: '/privacidade'
      path: '/privacidade'
      fullPath: '/privacidade'
      preLoaderRoute: typeof PrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redefinir-senha': {
      id: '/redefinir-senha'
      path: '/redefinir-senha'
      fullPath: '/redefinir-senha'
      preLoaderRoute: typeof RedefinirSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resultado': {
      id: '/resultado'
      path: '/resultado'
      fullPath: '/resultado'
      preLoaderRoute: typeof ResultadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/termos': {
      id: '/termos'
      path: '/termos'
      fullPath: '/termos'
      preLoaderRoute: typeof TermosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verificar-email': {
      id: '/verificar-email'
      path: '/verificar-email'
      fullPath: '/verificar-email'
      preLoaderRoute: typeof VerificarEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registro/$id': {
      id: '/registro/$id'
      path: '/registro/$id'
      fullPath: '/registro/$id'
      preLoaderRoute: typeof RegistroIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/treino/$id': {
      id: '/treino/$id'
      path: '/treino/$id'
      fullPath: '/treino/$id'
      preLoaderRoute: typeof TreinoIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CheckinRoute: CheckinRoute,
  ConfiguracoesRoute: ConfiguracoesRoute,
  ConfirmarNovoEmailRoute: ConfirmarNovoEmailRoute,
  EntrarRoute: EntrarRoute,
  EntrevistaRoute: EntrevistaRoute,
  EsqueciASenhaRoute: EsqueciASenhaRoute,
  HistoricoRoute: HistoricoRoute,
  NovidadesRoute: NovidadesRoute,
  PainelRoute: PainelRoute,
  PlanoRoute: PlanoRoute,
  PrivacidadeRoute: PrivacidadeRoute,
  RedefinirSenhaRoute: RedefinirSenhaRoute,
  ResultadoRoute: ResultadoRoute,
  TermosRoute: TermosRoute,
  VerificarEmailRoute: VerificarEmailRoute,
  RegistroIdRoute: RegistroIdRoute,
  TreinoIdRoute: TreinoIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
